/**
 * @generated SignedSource<<4f039a8fdc0c82a459c437ca140fd553>>
 * @relayHash f467b19617be3da5276560aa2bcdc381
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 085cb0967ad401fa806a01360f133cbfbb2eb21653a8a775ee9914232447353d

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentUnifiedWithSpaceKeyQuery$variables = {
  agentSessionsPropertyKey?: string | null;
  fetchAgentSessionsMarker?: boolean | null;
  includeAgentTrustReceiptData?: boolean | null;
  includeBylineContributors?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  spaceKey: string;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentUnifiedWithSpaceKeyQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentTitle_space">;
  } | null;
  readonly spaceHomepage: {
    readonly agentSessionsMarker?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly appearancePublished: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly body: {
      readonly dynamic: {
        readonly content: {
          readonly id: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null;
        readonly representation: string | null;
        readonly value: string | null;
        readonly webresource: {
          readonly superbatch: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly contentProperties?: {
      readonly latest: {
        readonly generatedBy: string | null;
      } | null;
    } | null;
    readonly contentTitleWithByLine?: {
      readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
    } | null;
    readonly history?: {
      readonly createdBy: {
        readonly displayName: string | null;
      } | null;
      readonly createdDate: string | null;
    } | null;
    readonly id: string | null;
    readonly labels?: {
      readonly count: number | null;
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly label: string | null;
        readonly name: string | null;
        readonly prefix: string | null;
      } | null> | null;
    } | null;
    readonly macroRenderedOutput?: ReadonlyArray<{
      readonly key: string | null;
      readonly value: {
        readonly representation: string | null;
        readonly value: string | null;
        readonly webresource: {
          readonly tags: {
            readonly css: string | null;
            readonly js: string | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
    readonly metadata: {
      readonly frontend: {
        readonly coverPictureWidth?: string | null;
        readonly fabricEditorSupported: boolean | null;
      } | null;
      readonly lastModifiedDate: string | null;
    };
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageTitlePublished?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
        readonly version: {
          readonly number: number | null;
        } | null;
      } | null> | null;
    } | null;
    readonly space: {
      readonly alias: string | null;
      readonly id: string | null;
      readonly key: string | null;
    } | null;
    readonly status: string | null;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
    readonly version: {
      readonly confRev: string | null;
      readonly number: number | null;
      readonly when?: string | null;
    } | null;
  } | null;
};
export type ContentUnifiedWithSpaceKeyQuery = {
  response: ContentUnifiedWithSpaceKeyQuery$data;
  variables: ContentUnifiedWithSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "agentSessionsPropertyKey"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchAgentSessionsMarker"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v9 = [
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  },
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "title"
},
v12 = {
  "kind": "ScalarField",
  "name": "type"
},
v13 = {
  "kind": "ScalarField",
  "name": "status"
},
v14 = {
  "kind": "ScalarField",
  "name": "number"
},
v15 = {
  "kind": "ScalarField",
  "name": "when"
},
v16 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "confRev"
    },
    (v14/*: any*/),
    {
      "condition": "includeAgentTrustReceiptData",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v15/*: any*/)
      ]
    }
  ]
},
v17 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "coverPictureWidth"
            }
          ]
        }
      ]
    }
  ]
},
v18 = {
  "kind": "ScalarField",
  "name": "representation"
},
v19 = {
  "kind": "ScalarField",
  "name": "value"
},
v20 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v14/*: any*/)
  ]
},
v21 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v18/*: any*/),
        (v19/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            (v20/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v22/*: any*/)
            },
            (v21/*: any*/)
          ]
        }
      ]
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "key"
},
v25 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      (v24/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/)
    ]
  }
],
v26 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v27 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v28 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "subType"
},
v30 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v24/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v32 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v33 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v34 = {
  "condition": "useNewContentTopper",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "pageTitlePublished",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "page-title-property-published"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v25/*: any*/),
      "storageKey": "properties(key:\"page-title-property-published\")"
    }
  ]
},
v35 = {
  "condition": "isSSR",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MapOfStringToFormattedBody",
      "kind": "LinkedField",
      "name": "macroRenderedOutput",
      "plural": true,
      "selections": [
        (v24/*: any*/),
        {
          "concreteType": "FormattedBody",
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": [
            (v19/*: any*/),
            (v18/*: any*/),
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": (v22/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "name"
},
v37 = {
  "condition": "preloadLabels",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASCENDING",
            "sortField": "LABELLING_CREATIONDATE"
          }
        }
      ],
      "concreteType": "PaginatedLabelList",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v10/*: any*/),
            {
              "kind": "ScalarField",
              "name": "label"
            },
            (v36/*: any*/),
            {
              "kind": "ScalarField",
              "name": "prefix"
            }
          ]
        }
      ],
      "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
    }
  ]
},
v38 = {
  "condition": "fetchAgentSessionsMarker",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "agentSessionsMarker",
      "args": [
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "agentSessionsPropertyKey"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v25/*: any*/)
    }
  ]
},
v39 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v40 = {
  "concreteType": "Theme",
  "kind": "LinkedField",
  "name": "theme",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "themeKey"
    },
    (v36/*: any*/)
  ]
},
v41 = {
  "kind": "ScalarField",
  "name": "background"
},
v42 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v43 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v44 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v45 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v46 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v47 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v48 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v49 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v50 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v51 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    (v49/*: any*/),
    (v50/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v41/*: any*/),
        (v42/*: any*/),
        (v43/*: any*/),
        (v44/*: any*/),
        (v45/*: any*/),
        (v46/*: any*/),
        (v47/*: any*/),
        (v48/*: any*/),
        (v49/*: any*/),
        (v50/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "padding"
},
v53 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v54 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    (v48/*: any*/),
    (v49/*: any*/),
    (v50/*: any*/),
    (v52/*: any*/),
    (v53/*: any*/)
  ]
},
v55 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v56 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v58 = [
  (v57/*: any*/),
  (v12/*: any*/),
  (v32/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "accountId"
      }
    ],
    "type": "KnownUser"
  },
  {
    "concreteType": "Icon",
    "kind": "LinkedField",
    "name": "profilePicture",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "path"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "spaceHomepage",
        "plural": false,
        "selections": [
          {
            "condition": "includeBylineContributors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "useNewContentTopper",
                          "variableName": "useNewContentTopper"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "ContentTitleWithByLine_content"
                    }
                  ],
                  "type": "Content"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "contentTitleWithByLine"
              }
            ]
          },
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v23/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          {
            "condition": "includeAgentTrustReceiptData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/)
                    ]
                  }
                ]
              },
              (v33/*: any*/)
            ]
          },
          (v34/*: any*/),
          (v35/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/)
        ]
      },
      {
        "args": (v39/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          (v10/*: any*/),
          (v40/*: any*/),
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v51/*: any*/),
                  (v54/*: any*/)
                ]
              }
            ]
          },
          (v55/*: any*/),
          (v56/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "spaceHomepage",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v23/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          {
            "condition": "includeBylineContributors",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "emojiTitlePublished",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "emoji-title-published"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": (v25/*: any*/),
                "storageKey": "properties(key:\"emoji-title-published\")"
              },
              {
                "alias": "editorProperty",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "key",
                    "value": "editor"
                  }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JsonContentProperty",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v24/*: any*/),
                      (v19/*: any*/)
                    ]
                  }
                ],
                "storageKey": "properties(key:\"editor\")"
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v36/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "homepageId"
                  }
                ]
              },
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": (v58/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "ownedBy",
                    "plural": false,
                    "selections": (v58/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "name": "lastOwnedBy",
                    "plural": false,
                    "selections": (v58/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "by",
                    "plural": false,
                    "selections": (v58/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "friendlyWhen"
                  },
                  (v15/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "contentTypeModified"
                  }
                ]
              },
              (v33/*: any*/),
              (v34/*: any*/)
            ]
          },
          {
            "condition": "includeAgentTrustReceiptData",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "createdBy",
                    "plural": false,
                    "selections": [
                      (v57/*: any*/),
                      (v32/*: any*/)
                    ]
                  }
                ]
              },
              (v33/*: any*/)
            ]
          },
          (v34/*: any*/),
          (v35/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/)
        ]
      },
      {
        "args": (v39/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          (v40/*: any*/),
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": [
                  (v24/*: any*/),
                  (v19/*: any*/)
                ]
              },
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v48/*: any*/),
                      (v42/*: any*/),
                      (v43/*: any*/),
                      (v47/*: any*/),
                      (v44/*: any*/),
                      (v46/*: any*/),
                      (v45/*: any*/),
                      (v53/*: any*/),
                      (v52/*: any*/)
                    ]
                  },
                  (v51/*: any*/),
                  (v54/*: any*/)
                ]
              }
            ]
          },
          (v55/*: any*/),
          (v56/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f467b19617be3da5276560aa2bcdc381",
    "id": "085cb0967ad401fa806a01360f133cbfbb2eb21653a8a775ee9914232447353d",
    "metadata": {},
    "name": "ContentUnifiedWithSpaceKeyQuery",
    "operationKind": "query",
    "text": "query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false){spaceHomepage(spaceKey:$spaceKey,version:$versionOverride){...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors),id,title,type,status,version{confRev,number,when@include(if:$includeAgentTrustReceiptData)},metadata{lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},operations{operation,targetType},subType,space{id,key,alias},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n    contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}},space(key:$spaceKey){...ContentTitle_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ByLine_content_2SjeOj on Content{id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}"
  }
};
})();

(node as any).hash = "7dd94d76ffccb43d91b0b4da6d19fde4";

export default node;
